import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { absoluteAssetUrl } from '../../constants/structuredData'
import { pageCanonicalUrl, pageSeoForPath, SEO_DEFAULTS } from '../../constants/pageSeo'
import { pageStructuredData } from '../../constants/structuredData'

const JSON_LD_ID = 'noor-json-ld'

function upsertMeta(selector, attributes) {
  let el = document.querySelector(selector)
  if (!el) {
    el = document.createElement('meta')
    document.head.appendChild(el)
  }
  Object.entries(attributes).forEach(([key, value]) => {
    el.setAttribute(key, value)
  })
}

function upsertLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

function upsertJsonLd(data) {
  let el = document.getElementById(JSON_LD_ID)
  if (!el) {
    el = document.createElement('script')
    el.id = JSON_LD_ID
    el.type = 'application/ld+json'
    document.head.appendChild(el)
  }
  el.textContent = JSON.stringify(data)
}

const PageMeta = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const seo = pageSeoForPath(pathname)
    const canonical = pageCanonicalUrl(pathname)
    const ogImage = absoluteAssetUrl(SEO_DEFAULTS.ogImagePath)

    document.title = seo.title

    upsertMeta('meta[name="description"]', { name: 'description', content: seo.description })
    upsertLink('canonical', canonical)

    upsertMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' })
    upsertMeta('meta[property="og:locale"]', {
      property: 'og:locale',
      content: SEO_DEFAULTS.locale,
    })
    upsertMeta('meta[property="og:site_name"]', {
      property: 'og:site_name',
      content: SEO_DEFAULTS.siteName,
    })
    upsertMeta('meta[property="og:url"]', { property: 'og:url', content: canonical })
    upsertMeta('meta[property="og:title"]', { property: 'og:title', content: seo.title })
    upsertMeta('meta[property="og:description"]', {
      property: 'og:description',
      content: seo.description,
    })
    upsertMeta('meta[property="og:image"]', { property: 'og:image', content: ogImage })
    upsertMeta('meta[property="og:image:alt"]', {
      property: 'og:image:alt',
      content: SEO_DEFAULTS.ogImageAlt,
    })
    upsertMeta('meta[property="og:image:width"]', {
      property: 'og:image:width',
      content: String(SEO_DEFAULTS.ogImageWidth),
    })
    upsertMeta('meta[property="og:image:height"]', {
      property: 'og:image:height',
      content: String(SEO_DEFAULTS.ogImageHeight),
    })

    upsertMeta('meta[name="twitter:card"]', {
      name: 'twitter:card',
      content: 'summary_large_image',
    })
    upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: seo.title })
    upsertMeta('meta[name="twitter:description"]', {
      name: 'twitter:description',
      content: seo.description,
    })
    upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: ogImage })
    upsertMeta('meta[name="twitter:image:alt"]', {
      name: 'twitter:image:alt',
      content: SEO_DEFAULTS.ogImageAlt,
    })

    upsertJsonLd(pageStructuredData(pathname, seo, canonical, ogImage))
  }, [pathname])

  return null
}

export default PageMeta
